import { Component, Input } from "@angular/core";
import { NzEmptyComponent } from "ng-zorro-antd/empty";

@Component({
  selector: 'app-no-data-found',
  standalone: true,
  imports: [
    NzEmptyComponent
  ],
  templateUrl: './no-data-found.component.html',
  styleUrl: './no-data-found.component.scss',
})
export class NoDataFoundComponent {
  @Input() msg: string = "No Data Found";
}
